import { createContext } from 'react';

export default createContext({
  open: null,
  setClaim: () => {},
  applyData: [],
  applyByKey: {},
})
